export enum LoadingStatus {
    LOADING,
    RELOADING,
    FAILED,
    LOADED
}
